import {Injectable} from "@angular/core";
import {BehaviorSubject} from 'rxjs';
import {Subject} from "rxjs/Subject";

@Injectable()
export class MenuResizeService {

    private _observer: BehaviorSubject<boolean>;

    constructor() {
        this._observer = new BehaviorSubject<boolean>(true);
    }

    onResizeMenuObserver(): Subject<boolean> {
        return this._observer;
    }

    changeSize(isLarge: boolean): void {
        this._observer.next(isLarge);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/menu/resizer/menu.resizer.service.ts